import { routeFrontOfficeSchoolFormathequeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeSchoolFormathequeCommonUser'
import { routeFrontOfficeSchoolRankingCommonUser } from '@/lib/routes/front/common/routeFrontOfficeSchoolRankingCommonUser'
import { routeFrontOfficeAllEntityGroupementChainCommon } from '@/lib/routes/front_groupement/common/routeFrontOfficeAllEntityGroupementChainCommon'
import { routeFrontOfficeSchoolGroupementChainCommon } from '@/lib/routes/front_groupement/common/routeFrontOfficeSchoolGroupementChainCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeSchoolGroupementChainListRoutesAllUser = [
  ...routeFrontOfficeSchoolFormathequeCommonUser,
  ...routeFrontOfficeAllEntityGroupementChainCommon,
  ...routeFrontOfficeSchoolGroupementChainCommon,
  // « Mon equipe » n'est plus ici : gestion reservee aux managers (getter MANAGER Group).
  ...routeFrontOfficeSchoolRankingCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_GROUPEMENT_CHAIN_USER],
}))

export default getFrontOfficeSchoolGroupementChainListRoutesAllUser
